import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';

const useStyles = makeStyles(({ theme }) => ({
    adminFormFields: {
        padding: theme.spacing(1, 2, 1.5, 2),
    }
}));

const AdminFormFields = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.adminFormFields}>
            {props.children}
        </div>
    );
};

AdminFormFields.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

export default AdminFormFields;
